import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 屋根ー軒の出設定ダイアログ
 */
class NokideSetting extends Dialog {
  initDone: boolean = false;// 初期化完了

  /**
   * コンストラクタ
   */
  constructor(draggable: boolean) {
    super(draggable);
    // ターゲットのお部屋
    this.initDone = false;

    // ダイアログのコンテンツ生成
    const id: string = 'nokideSettingDialog';
    let title: string = '';

    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Nokide Setting'; break;
      default: title = '軒の出設定'; break;
    }

    let contents: string = '<div class="dialogNokideSetting">\n';
    contents += '<span class="jp">軒の出の長さを入力してください。\n</span><span class="en">Please input the nokide length.</span>\n';
    contents += '<table>\n';
    contents += '<tbody>\n';
    contents += '<tr>\n';
    contents += '</tr>\n';
    contents += '<tr>\n';
    contents += '<th>\n<label for="nokide"><span class="jp">軒の出：</span><span class="en">nokide : </span></label></th>\n';
    contents += '<td>\n<input type="number" name="nokide" id="nokide">\n<td>mm</td>\n</td>\n';
    contents += '</tr>\n';

    contents += '</tbody>\n';
    contents += '</table>\n';
    contents += '</div>';

    let footer: string = '<button id="btnDoneRoofSetting"><span class="jp">ＯＫ</span><span class="en">OK</span></button>';
    footer += '<button id="btnClose"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>';

    this.createDialog(id, title, contents, footer);

    // ダイアログの初期設定
    this.initMe();

    // イベント設定
    const btn: Element = document.querySelector('#btnDoneRoofSetting');
    btn.addEventListener('click', this.updateRoofSetting);

    document.getElementById('btnClose').addEventListener('click', () => {
      marietta.webcad.WebCADGlobal.removeDialog();
    });
  }

  /**
   * ダイアログの初期設定
   */
  initMe() {
    // 取り付け高さの設定
    (<HTMLInputElement>document.getElementById('nokide')).value = String(marietta.webcad.WebCADGlobal.webcad2Dmanager.noki_de);

    // 初期化完了フラグ
    this.initDone = true;
  }

  /**
   * 屋根設定の反映
   */
  updateRoofSetting = () => {
    // MIN&MAXの制限
    const nokide = Number((<HTMLInputElement>document.getElementById('nokide')).value);
    if (nokide > 999) {
      let message: string;
      if (marietta.webcad.WebCADGlobal.language === 'jp') {
        message = '軒の出には0mm以上、1000mm未満の数値を入力してください。';
      } else {
        message = 'Please input from 0mm to 999mm for the nokide.';
      }
      marietta.webcad.WebCADGlobal.showAlert(message, marietta.webcad.collection.WebCADMessages.getText('ERROR_TITLE'));
      return;
    }

    // 取り付け高さの設定
    marietta.webcad.WebCADGlobal.webcad2Dmanager.noki_de = Number((<HTMLInputElement>document.getElementById('nokide')).value);

    // 屋根の形状を全て取得＆適用
    marietta.webcad.WebCADGlobal.itemManager.getAllRoofs();

    // ダイアログを閉じる
    this.close();
  }
}

export default NokideSetting;
